module.exports = __webpack_public_path__ + "img/1-2-1.d6a9cba1.png";